export const ENTERPRISE_ADMIN_COACH_MODE_ID = 'ENTERPRISE_ADMIN';

export const ENTERPRISE_ADMIN_COACH_REF = 'admin-coach';

export const ENTERPRISE_ADMIN_COACH_FILTERS_STORAGE_KEYS = {
  PROGRAMS: 'admin-coach-filters:programs',
  CONTRACTS: 'admin-coach-filters:contracts',
  SKILLS: 'admin-coach-filters:skills',
  LEARNER_STATUSES: 'admin-coach-filters:learner-statuses',
  DATE_RANGE: 'admin-coach-filters:date-range',
  LAST_FILTER_UPDATED_AT: 'admin-coach-filters:last-filter-updated-at',
} as const;
